import { render, staticRenderFns } from "./room-type.vue?vue&type=template&id=47d9c3dc&scoped=true&"
import script from "./room-type.vue?vue&type=script&lang=js&"
export * from "./room-type.vue?vue&type=script&lang=js&"
import style0 from "./room-type.vue?vue&type=style&index=0&id=47d9c3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9c3dc",
  null
  
)

export default component.exports